import { Injectable } from '@angular/core';
import { BaseService } from '../base.service';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ToolsService } from '../../tools/tools.service';
import { Base2Service } from '../base2.service';
import { BaseclientService } from '../../apiclient/baseclient.service';
import {SalemethodService} from "../salemethod/salemethod.service";

@Injectable({
  providedIn: 'root'
})
export class InfoNoteService {

  constructor(
    private base: BaseService,
    private tools: ToolsService,
    private base2: Base2Service,
    private baseClient: BaseclientService
  ) { }

  getInfosNote(): Observable<any> |any {

    const sm:any = this.tools.getStor(SalemethodService.TAG_STORAGE);

    if (sm) {


      const params = { id_sale_method: sm.id };

       return from(this.baseClient.postBaseApi("attributes", params)).pipe(




        map(infos => {


          const filteredInfos = infos.list.filter((info:any) => info.archive === 0 && info.sale_methods.length > 0);


          if (filteredInfos.length > 0) {

            // Adding value proprety to info object
            filteredInfos.map((info:any) => {
              info.value = "";
            })

            return filteredInfos;

          }

        })
      )
    }

  }

}
